export function inr(value, compact = false) {
  const n = Number(value || 0);
  if (compact && Math.abs(n) >= 100000) {
    if (Math.abs(n) >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
    return `₹${(n / 100000).toFixed(2)} L`;
  }
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
}

export function acres(n) {
  const v = Number(n || 0);
  return `${v} ac (${(v * 0.4047).toFixed(2)} ha)`;
}

export function shortDate(d) {
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  } catch {
    return "";
  }
}

export function ndviColor(v) {
  if (v >= 0.7) return "#16a34a";
  if (v >= 0.55) return "#65a30d";
  if (v >= 0.45) return "#ca8a04";
  if (v >= 0.35) return "#ea580c";
  return "#dc2626";
}

export function ndviLabel(v) {
  if (v >= 0.7) return "Excellent";
  if (v >= 0.55) return "Healthy";
  if (v >= 0.45) return "Moderate";
  if (v >= 0.35) return "Stressed";
  return "Poor";
}

// NDVI (0-1) → farmer-friendly health score out of 100
export function healthScore(v) {
  return Math.round(Number(v || 0) * 100);
}

export function healthColor(score) {
  if (score > 55) return "#16a34a";
  if (score >= 40) return "#ca8a04";
  return "#dc2626";
}

// ISO date → "2 Jul, 5:00 pm"
export function stamp(iso) {
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "numeric", month: "short", hour: "numeric", minute: "2-digit", hour12: true,
    });
  } catch {
    return "";
  }
}
